/**
 * User: liliana
 * Date: 11/10/14
 * Time: 11:07 AM
 * Copyright 1stdibs.com, Inc. 2013. All Rights Reserved.
 */

"use strict";

// ---------------------------------------------------
// Load Super Class
var Backbone = require('dibs-backbone');
var SoaModel = require('bunsen/models/SoaModel');

// ---------------------------------------------------
// Module Definition

/**
 * Model for Attribute data via Attribute Service, e.g.:
 * {
 *     "id": 7595,
 *     "name": "Costa Rica",
 *     "urlLabel": "costa-rica",
 *     "status": "ACTIVE",
 *     "properties": {
 *         "displayName": "Costa Rican"
 *     },
 *     "pageExists": "Y",
 *     "parent": {
 *        "id": 7589
 *     }
 * },
 * @class Attribute
 * @extends SoaModel
 */
var Attribute = module.exports = SoaModel.extend();

// ---------------------------------------------------
// Dependencies

var _ = require('underscore');
var Attributes = require('bunsen/collections/inventory/Attributes');
var ItemAttribute = require('bunsen/models/inventory/ItemAttribute');

// ---------------------------------------------------
// Local Vars

// ---------------------------------------------------
// Define Module Instance Properties

_.extend(Attribute.prototype, {
    relations : [
        {
            type: Backbone.One,
            key: 'properties',
            relatedModel: SoaModel.extend()
        },
        {
            type: Backbone.Many,
            key: 'child',
            collectionType: Attributes
        }
    ],
    toItemAttribute: function (omitChild) {
        var child = this.get('child') || [];
        var data = {
            value: this.get('name'),
            option: {
                id: this.get('id'),
                urlLabel: this.get('urlLabel'),
                displayConfigs: this.get('displayConfigs') || null
            }
        };

        if (!omitChild && child.length) {
            data.child = child.toItemAttributes(omitChild);
        }

        return new ItemAttribute(data);
    }
});

// ---------------------------------------------------
// Define Module Static Properties

_.extend(Attribute, {

});


//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/inventory/Attribute.js
// module id = 2647
// module chunks = 63